import { useEffect, useRef, useState, MouseEvent, TouchEvent } from 'react'

export const useControlledTooltip = () => {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const handleTooltipClose = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => setTooltipOpen(false), 200)
  }

  const handleTooltipOpen = (e: MouseEvent | TouchEvent) => {
    e.stopPropagation()
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    setTooltipOpen(true)
  }

  useEffect(() => {
    if (!tooltipOpen) return

    const handleTouchMove = () => {
      setTooltipOpen(false)
    }

    window.addEventListener('touchmove', handleTouchMove, { passive: true })

    return () => {
      window.removeEventListener('touchmove', handleTouchMove)
    }
  }, [tooltipOpen])

  const tooltipListeners = {
    onMouseEnter: handleTooltipOpen,
    onClick: handleTooltipOpen,
    onTouchStart: handleTooltipOpen,
    onMouseLeave: handleTooltipClose,
  }

  return {
    handleTooltipClose,
    handleTooltipOpen,
    tooltipOpen,
    setTooltipOpen,
    tooltipListeners,
  }
}
